export default function Util_FormatearNumero(monto, digitos = 2,separarMiles = true) {


  if (monto === null || monto === undefined || monto === '') {
    return '';
  }

  const montoNumerico = Number(monto);

  if (isNaN(montoNumerico)) {
    return '';
  }

  // Si se requieren separadores de miles
  if (separarMiles) {
    return montoNumerico.toLocaleString('en-US', {
      minimumFractionDigits: digitos,
      maximumFractionDigits: digitos
    });
  }

  // Sin separadores de miles
  return montoNumerico.toFixed(digitos);
}

